import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Dialog from './components/common/Dialog/dialog.js'
import Toast from './components/common/Toast/toast.js'
import router from './router/index.js'


Vue.use(Dialog)
Vue.use(Toast)
Vue.use(ElementUI);
Vue.config.productionTip = false
console.log(router)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
